import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const AgentProductivityService = {
    apply: async (payload) => axios.post(`${API_URL}/reports/agent-productivity/apply`, payload).then(({data}) => data.data).catch((err) => { throw err })
};

export default AgentProductivityService;